import { evalExpression } from 'ng-formly/src/core/utils';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldType } from 'ng-formly';
import { EntityrecordApi } from '../../sdk/services/custom';
import { LoopBackFilter } from '../../sdk/models/';
import * as _ from 'lodash';
import { PlatformApp } from '../../services/app.service';
import { CacheService } from 'ng2-cache/ng2-cache';

/*
This custom field is used to select records for an app.
*/

@Component({
	selector: 'formly-entityrecord-selector',
	template: `
   <ng-select *ngIf='items.length > 0'   
             [active]='selectedvalues'
              (data)='refreshValue($event)'
              (selected)='selected($event)'
              (removed)='removed($event)' 
              [items]='items'
              [multiple] = 'false'
              [disabled]='to.disabled'
              placeholder='' 
			  [allowClear]="!to.required" >
  </ng-select>
  `, styleUrls: ['./ng2select.scss'],
	providers: [EntityrecordApi]
})
export class EntityRecordSelect extends FieldType implements OnInit, OnDestroy {
	_loopbackfilter: LoopBackFilter = <LoopBackFilter>{};
	items: any = [];
	selectedvalues: any = [];
	parentFieldValue = null;
	formulae = [];
	modelValues = [];

	constructor(private _EntityrecordApi: EntityrecordApi, private _cacheService: CacheService) {
		super();
	}

	ngOnInit() {
		if (!this.form['subscriptions'])
			this.form['subscriptions'] = [];

		// Adding new Controls to hold formControls for hidden fields
		if (!this.form['newcontrols'])
			this.form['newcontrols'] = {};
		for (let key in this.form.controls) {
			this.form['newcontrols'][key] = this.form.controls[key];
		}

		if (this.field['formulae']) {
			this.formulae = this.field['formulae'];
			if (this.field.formControl) {
				this.addWatcher(this.field.formControl);
			}
		}

		if (this.field.defaultValue && !this.model[this.key])
			this.formControl.setValue(this.field.defaultValue);

		this.items = [];
		if (this.field['parentEntityFieldName']) {
			if (this.form['newcontrols'][this.field['parentEntityFieldName']]) {
				if (!this.form.controls[this.field['parentEntityFieldName']]) {
					this.form.addControl(this.field['parentEntityFieldName'], this.form['newcontrols'][this.field['parentEntityFieldName']]);
				} else {
					this.form.setControl(this.field['parentEntityFieldName'], this.form['newcontrols'][this.field['parentEntityFieldName']]);
				}
			}

			if (this.form.controls[this.field['parentEntityFieldName']]) {
				this.form['subscriptions'].push(this.form.controls[this.field['parentEntityFieldName']].valueChanges.subscribe((updatedValue: any) => {
					if (updatedValue) {
						delete this.model[this.key];
						delete this.model[this.key + '_object'];
						this.items = [];
						//Get the field from the CacheService
						let fields = this._cacheService.get('formfields');
						let field = _.find(fields, { 'key': updatedValue });
						if (field['lookupfield']) {
							let expProp = field['expressionProperties'];
							if (expProp && (expProp.hasOwnProperty('lookupfield') || expProp.hasOwnProperty('lookupfieldname'))) {
								if (expProp.hasOwnProperty('lookupfield')) {
									this.field['lookupfield'] = evalExpression(expProp['lookupfield'].expression, this, [this.model, this.options.fromState]);
								}
								if (expProp.hasOwnProperty('lookupfieldname')) {
									this.field['lookupfieldname'] = evalExpression(expProp['lookupfieldname'].expression, this, [this.model, this.options.fromState]);
								}
							} else {
								this.field['lookupfield'] = field['lookupfield'];
								this.field['lookupfieldname'] = field['lookupfieldname'];
							}
							this.setLookupValues();
						}
					}
				}));
			}
		}

		// Setting data element filter
		if (this.field['cascaded'] && this.field['parentFieldName']) {
			if (this.form['newcontrols'][this.field['parentFieldName']]) {
				if (!this.form.controls[this.field['parentFieldName']]) {
					this.form.addControl(this.field['parentFieldName'], this.form['newcontrols'][this.field['parentFieldName']]);
				} else {
					this.form.setControl(this.field['parentFieldName'], this.form['newcontrols'][this.field['parentFieldName']]);
				}
			}

			if (this.form.controls[this.field['parentFieldName']]) {
				this.form['subscriptions'].push(this.form.controls[this.field['parentFieldName']].valueChanges.subscribe((updatedValue: any) => {
					if (updatedValue) {
						this.parentFieldValue = updatedValue;
						this.selectedvalues = [];
						this.value = null;
						this.setLookupValues();
					}
				}));
				if (this.model[this.field['parentFieldName']]) {
					this.form.controls[this.field['parentFieldName']].setValue(this.model[this.field['parentFieldName']]);
				}
			}
		} else {
			if (this.field['lookupfield'])
				this.setLookupValues();
			else
				this.field.formControl.disable();
		}
	}

	private setLookupValues() {

		let expProp = this.field['expressionProperties'];
		if (expProp && (expProp.hasOwnProperty('lookupfield') || expProp.hasOwnProperty('lookupfieldname'))) {
			if (expProp.hasOwnProperty('lookupfield')) {
				this.field['lookupfield'] = evalExpression(expProp['lookupfield'].expression, this, [this.model, this.options.fromState]);
			}
			if (expProp.hasOwnProperty('lookupfieldname')) {
				this.field['lookupfieldname'] = evalExpression(expProp['lookupfieldname'].expression, this, [this.model, this.options.fromState]);
			}
		}
		this.items = [];
		//1) Load the drop down values    
		this._loopbackfilter.where = {};
		this._loopbackfilter.where['appId'] = this.model.appId;
		this._loopbackfilter.where['entityId'] = this.field['lookupfield'];
		if (this.field['cascaded'] && this.field['parentFieldLookupName']) {
			if (Array.isArray(this.parentFieldValue)) {
				this._loopbackfilter.where['data.' + this.field['parentFieldLookupName']] = { inq: this.parentFieldValue };
			} else {
				this._loopbackfilter.where['data.' + this.field['parentFieldLookupName']] = this.parentFieldValue;
			}
		}

		//Get the records for the App
		this.form['subscriptions'].push(this._EntityrecordApi.find(this._loopbackfilter).subscribe((records) => {
			if (records) {
				this.items = [];
				for (let i = 0; i < records.length; i++) {
					//Values to shown
					this.items.push({ id: records[i]['id'], text: "" + records[i]['data'][this.field['lookupfieldname']] });
					//Selected Values
					if (this.model[this.key] && this.model[this.key].indexOf(records[i]['id']) > -1) {
						this.selectedvalues = [{ id: records[i]['id'], text: "" + records[i]['data'][this.field['lookupfieldname']] }];
					}
				}
				//Sort the values
				this.items = _.sortBy(this.items, 'text');
				if (this.items.length == 1) {
					this.selectedvalues = _.cloneDeep(this.items);
					this.field.formControl.setValue(this.items[0].id);
					this.field.templateOptions.disabled = true;
				} else {
					this.field.templateOptions.disabled = false;
				}
			}
		}));
	}

	private addWatcher(formControl) {
		this.form['subscriptions'].push(formControl.valueChanges.subscribe((updatedValue: any) => {
			for (let i = 0; i < this.formulae.length; i++) {
				let formula = this.formulae[i];
				if (this.setModelValues(formula['fields'], updatedValue)) {
					this.setResults(formula['results'], PlatformApp.processData(formula['formula'], this.modelValues));
				}
			}
		}));
	}

	private setModelValues(fieldArray, updatedValue) {
		let requiredFieldsExist = true;
		this.modelValues = [];
		for (let j = 0; j < fieldArray.length; j++) {
			if (!this.model[fieldArray[j]]) {
				requiredFieldsExist = false;
				break;
			} else {
				if (fieldArray[j] == this.field.key) {
					this.modelValues.push(updatedValue);
				} else {
					this.modelValues.push(this.model[fieldArray[j]]);
				}
			}
		}
		return requiredFieldsExist;
	}

	private setResults(resultArray, value): void {
		for (let i = 0; i < resultArray.length; i++) {
			let resultField = resultArray[i];
			if (this.form.controls[resultField]) {
				this.form.controls[resultField].setValue(value);

				if (this.form['newcontrols'][resultField] && !this.model[resultField]) {
					this.form.setControl(resultField, this.form['newcontrols'][resultField]);
					this.form.controls[resultField].setValue(value);
				}
			} else {
				if (this.form['newcontrols'][resultField]) {
					this.form.addControl(resultField, this.form['newcontrols'][resultField]);
					this.form.controls[resultField].setValue(value);
				} else {
					this.model[resultField] = value;
				}
			}
		}
	}

	ngOnDestroy() {
		this.selectedvalues = [];
	}

	value: any = {};

	public selected(value: any): void {
		if (value && value.id)
			this.formControl.setValue(value.id);
	}

	public removed(value: any): void {
		if (value && value.id)
			if (this.model[this.key] && this.model[this.key].length)
				this.model[this.key].splice(this.model[this.key].indexOf(value.id), 1);
	}

	public typed(value: any): void {

	}

	public refreshValue(value: any): void {
		this.value = "" + value;
	}

}





// WEBPACK FOOTER //
// ./src/app/shared/components/fields/selectentityrecord.ts